import { useSticker } from 'hooks/business/im/sticker';
import styled from '@emotion/styled';
import { StickerMessage } from 'components/Dialogue';
import { useTranslate } from '@tolgee/react';
import { toUpperCase } from 'utils/toLowerCase';

export interface LazyStikcerMessageProps {
  region: General.CaselessRegion;
  platform: General.PlatformUpperCase;
  dataSource: {
    packageId: string;
    stickerId: string;
  };
  lazyScrollContainer?: Element | null;
}

const EmptySticker = styled.div`
  display: flex;
  height: 180px;
  width: 150px;
  padding: 0 10px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.1);
  white-space: pre-wrap;
  word-wrap: break-word;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.2);
`;

const LazyStickerMessage = ({
  platform,
  region,
  dataSource,
  lazyScrollContainer,
}: LazyStikcerMessageProps) => {
  const { packageId: pid, stickerId: sid } = dataSource;
  const { t } = useTranslate();

  const { loading, sticker } = useSticker({
    pid,
    sid,
    channel: toUpperCase(platform),
    region: toUpperCase(region),
  });

  if (loading) {
    return <div className="w-[160px] h-[160px] bg-content-400 opacity-10" />;
  }

  if (!sticker) {
    return (
      <EmptySticker>
        {t('scene.chatWorkspace.messageThread.lazyCard.stickerLoadFailed')}
      </EmptySticker>
    );
  }

  const { ossStickerAddress } = sticker;

  return <StickerMessage src={ossStickerAddress} lazyScrollContainer={lazyScrollContainer} />;
};

export default LazyStickerMessage;
